import { z } from 'zod';
import { id, timestamp, paginationQuery } from './common.js';

export const bookingRateSide = z.enum(['professional', 'office']);
export type BookingRateSide = z.infer<typeof bookingRateSide>;
export const bookingRateChangeStatus = z.enum([
  'pending',
  'accepted',
  'rejected',
  'withdrawn',
  'expired',
]);
export const bookingRateChange = z.object({
  id,
  bookingId: id,
  baseRevision: z.number().int().nonnegative(),
  fromRateCents: z.number().int().positive(),
  proposedRateCents: z.number().int().positive(),
  reason: z.string(),
  proposerUserId: id,
  proposerName: z.string(),
  proposerSide: bookingRateSide,
  createdAt: timestamp,
  expiresAt: timestamp,
  status: bookingRateChangeStatus,
  decidedAt: timestamp.nullable(),
  decidedByUserId: id.nullable(),
  deciderName: z.string().nullable(),
  canAccept: z.boolean(),
  canReject: z.boolean(),
  canWithdraw: z.boolean(),
});
export type BookingRateChange = z.infer<typeof bookingRateChange>;
export const bookingRateChangeView = z.object({
  bookingId: id,
  locationName: z.string(),
  timezone: z.string(),
  postedRateCents: z.number().int().nullable(),
  currentRateCents: z.number().int().nullable(),
  revision: z.number().int().nonnegative(),
  callerSide: bookingRateSide,
  canPropose: z.boolean(),
  unavailableReason: z.string().nullable(),
  items: z.array(bookingRateChange),
  page: z.number().int().positive(),
  pageSize: z.number().int().positive(),
  total: z.number().int().nonnegative(),
  totalPages: z.number().int().nonnegative(),
});
export type BookingRateChangeView = z.infer<typeof bookingRateChangeView>;
export const bookingRateChangeQuery = paginationQuery;
export const proposeBookingRateChangeInput = z
  .object({
    clientRequestId: z.string().uuid(),
    expectedRevision: z.number().int().nonnegative(),
    proposedRateCents: z.number().int().min(1).max(1000000),
    reason: z.string().trim().min(1).max(1000),
    expiresInHours: z.number().int().min(1).max(72).default(24),
  })
  .strict();
export type ProposeBookingRateChangeInput = z.infer<typeof proposeBookingRateChangeInput>;
export const respondBookingRateChangeInput = z
  .object({
    clientRequestId: z.string().uuid(),
    decision: z.enum(['accept', 'reject', 'withdraw']),
  })
  .strict();
export type RespondBookingRateChangeInput = z.infer<typeof respondBookingRateChangeInput>;
